import {css} from '../utils';

export default css`
    /* Each additional selector increases our styles' specificity. This trick
   allows us to override bootstrap styles. */
    .section-heading.section-heading.section-heading {
        display: flex;
        flex-direction: column;
        max-width: 840px;
        gap: 8px;
    }

    .section-heading-title.section-heading-title.section-heading-title {
        font-family: ${({theme}) => theme.font_family_header ?? 'Inter'};
        font-size: ${({theme}) => theme.section_title_font_size ?? '24px'};
        font-weight: 400;
        margin: 0;
    }

    .section-heading-subtitle.section-heading-subtitle.section-heading-subtitle {
        font-family: ${({theme}) => theme.font_family ?? 'Inter'};
        font-size: ${({theme}) => theme.font_size ?? '16px'};
        font-weight: 400;
        margin: 0;
    }
`;
